import { combineReducers } from "redux";
import {
  authorization,
  profile,
  currentRoute,
  notifications,
  app,
  usersForm,
  users,
  alerts,
  alertsForm,
  currentTheme,
  rawmaterials,
  rawmaterialsForm,
  zones,
  zonesForm,
  machines,
  machinesForm,
  repcon,
  navProducts,
  finishedproducts,
  finishedproductsForm,
  clients,
  clientsForm,
  clientproducts,
  clientproductsForm,
} from "./Reducers";

export default combineReducers({
  machines,
  machinesForm,
  zones,
  zonesForm,
  rawmaterials,
  rawmaterialsForm,
  app,
  authorization,
  currentRoute,
  profile,
  notifications,
  usersForm,
  users,
  alerts,
  alertsForm,
  currentTheme,
  repcon,
  navProducts,
  finishedproducts,
  finishedproductsForm,
  clients,
  clientsForm,
  clientproducts,
  clientproductsForm,
});
